import React from 'react'
import imglogo from '../../assets/img/logo_t4i.png'
import bgAuthenticate from '../../assets/img/bg-authenticate.png'
import createHttp from '../../lib/http'
import './login.css'
import classNames from 'classnames'
import { useIntl } from 'react-intl'
import { DEMO_USER } from '../../utils/constants'

import { Loader } from '../../components/loader'
import { useHistory } from 'react-router-dom'
import paths from '../../routes/paths'
import { useAuthentication } from '../../customHooks/useAuthentication'
import useDocumentTitle from '../../hooks/useDocumentTitle'
import { parseLoginPendingDeletion } from '../Account/account.utils'
import { LOGIN_LIFECYCLE_CODES } from '../Account/lifecycle/lifecycle.constants'
import { extractLifecycleCode, extractLifecycleMessage } from '../Account/lifecycle/lifecycle.utils'
import { SignupLifecycleNotice } from './signup/components/SignupLifecycleNotice'
import { requestAndRegisterToken } from '../../services/firebaseMessaging'
import { GoogleContinueButton } from './staffGoogle/GoogleContinueButton'
// import { PermissionContext } from "../../context/PermissionContext";

function Login() {
  // const { permissions } = React.useContext(PermissionContext);
  const { formatMessage: trans } = useIntl()
  const [login_data, setLoginData] = React.useState({ email: '', password: '' })
  const [in_response, setInResponse] = React.useState(false)
  const [total_errors, setTotalErrors] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [isLoadingPage, setLoadingPage] = React.useState(true)
  const [lifecycleNotice, setLifecycleNotice] = React.useState(null)
  const history = useHistory()

  const { setCurrentToken, deleteItemFromLocalStorage, updateUserInfo, saveItemInLocalStorage } = useAuthentication()
  useDocumentTitle(`Login`)

  deleteItemFromLocalStorage('item_validation_info')

  const gotoSignUp = () => {
    history.push('/sign_up')
  }

  const validateEmail = (email) => {
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  }

  const handleEmailChange = (event) => {
    setLifecycleNotice(null)
    setLoginData((prev) => ({ ...prev, email: event.target.value }))
  }

  const handlePasswordChange = (event) => {
    setLifecycleNotice(null)
    setLoginData((prev) => ({ ...prev, password: event.target.value }))
  }

  const addNewError = (error) => {
    setTotalErrors((total_errors) => [...total_errors, error])
  }

  const haveErrors = (field) => {
    let have_errors = total_errors.find((item) => {
      if (item.name === field) return item
    })

    if (have_errors !== undefined) {
      return true
    }

    return false
  }

  const returnErrorMsg = (field) => {
    let have_errors = total_errors.find((item) => {
      if (item.name === field) {
        return item
      }
    })

    if (have_errors !== undefined) {
      return have_errors.message
    }
  }

  const DemoLogin = (e) => {
    const headers = {
      'Content-Type': 'application/json, application/x-www-form-urlencoded',
      Accept: 'application/json',
      'X-CSRF-TOKEN': 'jmYydI75VCrZfAQIDrrjb6074EwpPSs47Y4au8Yl7AE=',
    }

    let formData = new FormData()
    formData.append('email', DEMO_USER)
    formData.append('password', '@4114RPrp!!')

    setIsLoading(true)
    createHttp
      .post('api/login', formData, { headers: headers })
      .then((res) => {
        if (res.data.status) {
          localStorage.setItem('jwt_token', JSON.stringify(res.data.access_token))
          setCurrentToken(JSON.parse(localStorage.getItem('jwt_token')))
          updateUserInfo(res.data.user, { replace: true })
          loginAction()
          return
        }
        if (!res.data.status) {
          addNewError({ name: 'email', message: res.data.message })
          addNewError({ name: 'password', message: res.data.message })
        }

        setInResponse(false)
        setIsLoading(false)
      })
      .catch((err) => {
        addNewError({ name: 'email', message: 'SERVER ERROR' })
        addNewError({ name: 'password', message: 'SERVER ERROR' })
        setInResponse(false)
        setIsLoading(false)
      })
  }

  const applyLoginLifecycle = (res) => {
    const rawCode = res?.data?.code || res?.data?.error
    if (rawCode === 'email_verification_required') {
      saveItemInLocalStorage('item_validation_info', {
        email: login_data.email,
        phoneNumber: '',
      })
      history.push('/validation_selection')
      return true
    }
    const code = extractLifecycleCode(res)
    if (LOGIN_LIFECYCLE_CODES.has(code)) {
      setLifecycleNotice({ code, message: extractLifecycleMessage(res) })
      return true
    }
    const pending = parseLoginPendingDeletion(res)
    if (pending) {
      setLifecycleNotice({ code: 'deletion_pending', message: pending.message || extractLifecycleMessage(res) })
      return true
    }
    return false
  }

  const sendLogin = () => {
    if (in_response) return

    setInResponse(true)
    setTotalErrors([])
    setLifecycleNotice(null)

    let errors = 0

    if (!validateEmail(login_data.email)) {
      addNewError({ name: 'email', message: 'Enter a valid email' })
      errors++
    }

    if (login_data.password.trim().length < 6) {
      addNewError({ name: 'password', message: 'Password cannot be lower than 6 characters' })
      errors++
    }

    if (errors > 0) {
      setInResponse(false)
      return
    }

    let formData = new FormData()
    formData.append('email', login_data.email)
    formData.append('password', login_data.password)

    setIsLoading(true)
    createHttp
      .post('api/login', formData)
      .then((res) => {
        // createHttp error interceptor returns error.response (403 resolves here, not .catch)
        if (applyLoginLifecycle(res)) {
          setTotalErrors([])
          setInResponse(false)
          setIsLoading(false)
          return
        }
        if (res?.data?.status) {
          localStorage.setItem('jwt_token', JSON.stringify(res.data.access_token))
          setCurrentToken(JSON.parse(localStorage.getItem('jwt_token')))
          updateUserInfo(res.data.user, { replace: true })
          loginAction()
          return
        }
        const failMessage = res?.data?.message || trans({ id: 'account_restore_failed', defaultMessage: 'Could not sign in. Check your email and password.' })
        addNewError({ name: 'email', message: failMessage })
        addNewError({ name: 'password', message: failMessage })
        setInResponse(false)
        setIsLoading(false)
      })
      .catch((err) => {
        if (applyLoginLifecycle(err)) {
          setTotalErrors([])
          setInResponse(false)
          setIsLoading(false)
          return
        }
        addNewError({ name: 'email', message: 'SERVER ERROR' })
        addNewError({ name: 'password', message: 'SERVER ERROR' })
        setInResponse(false)
        setIsLoading(false)
      })
  }

  const gotoForgetPassword = () => {
    history.push('/forgot_password')
  }

  const completeLoginRedirect = () => {
    const loginCount = JSON.parse(localStorage.getItem('login_count'))
    if (loginCount == null || loginCount <= 0) {
      localStorage.setItem('login_count', JSON.stringify(1))
    }
    requestAndRegisterToken()
    history.replace(paths.dashboard)
  }

  const loginAction = () => {
    completeLoginRedirect()
  }

  React.useEffect(() => {
    let cancelled = false
    const token = (() => {
      try {
        return JSON.parse(localStorage.getItem('jwt_token'))
      } catch {
        return null
      }
    })()

    if (!token) {
      setLoadingPage(false)
      return undefined
    }

    setCurrentToken(token)
    completeLoginRedirect()
    if (!cancelled) setLoadingPage(false)

    return () => {
      cancelled = true
    }
  }, [])

  return (
    <>
      {isLoadingPage && <Loader />}
      {!isLoadingPage && (
        <div className="login">
          {/* Left Split (Hero Image) */}
          <div className="hero-split">
            <img alt="Tech4Inventory Warehouse" className="hero-image" src={bgAuthenticate} />
          </div>

          {/* Right Split (Login Form) */}
          <div className="form-split">
            <div className="form-container">
              {/* Logo Section */}
              <div className="form-container_top">
                <img alt="Tech4Inventory Logo" className="logo" src={imglogo} />
                <h1 className="title-app">Tech4Inventory</h1>
                <span className="subtitle-app">Access to your account</span>
              </div>

              {/* Login Form */}
              <div className="form">
                <div className="theinputs">
                  {/* Email Field */}
                  <div className="input-group">
                    <label htmlFor="userName" className="label">
                      Email Address
                    </label>
                    <div className="relative-input-wrapper">
                      <span className="input-icon material-symbols-outlined">mail</span>
                      <input
                        type="text"
                        className={classNames('input', 'input-email', 'input-with-icon', {
                          'is-invalid': haveErrors('email'),
                        })}
                        name="userName"
                        id="userName"
                        placeholder="user@tech4inventory.com"
                        onChange={handleEmailChange}
                      />
                    </div>
                    {haveErrors('email') && (
                      <p className="message_error">
                        <span>{returnErrorMsg('email')}</span>
                      </p>
                    )}
                  </div>

                  {/* Password Field */}
                  <div className="input-group">
                    <label htmlFor="userPassword" className="label">
                      Password
                    </label>
                    <div className="relative-input-wrapper">
                      <span className="input-icon material-symbols-outlined">lock</span>
                      <input
                        type="password"
                        className={classNames('input', 'input-password', 'input-with-icon', {
                          'is-invalid': haveErrors('password'),
                        })}
                        name="userPassword"
                        id="userPassword"
                        placeholder="••••••••"
                        onChange={handlePasswordChange}
                      />
                    </div>
                    {haveErrors('password') && (
                      <p className="message_error">
                        <span>{returnErrorMsg('password')}</span>
                      </p>
                    )}
                  </div>

                  {lifecycleNotice ? <SignupLifecycleNotice code={lifecycleNotice.code} apiMessage={lifecycleNotice.message} email={login_data.email} /> : null}

                  {/* Actions */}
                  <button disabled={in_response} className="primary-button" onClick={() => sendLogin()}>
                    {isLoading && (
                      <div className="spinner-border spinner-border-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                    {!isLoading && 'Log In'}
                  </button>
                  <a onClick={gotoForgetPassword} className="forgot-password">
                    Forgot password?
                  </a>
                </div>

                {/* Divider */}
                <div className="divider-container">
                  <div className="divider-line"></div>
                  <span className="divider-text">OR</span>
                  <div className="divider-line"></div>
                </div>

                {/* Secondary Actions */}
                <div className="secondary-actions">
                  <GoogleContinueButton purpose="login" />
                  <button className="secondary-button" onClick={gotoSignUp}>
                    Sign up for new account
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Login
